/* FeetUp Quiz engine — routing, state, analytics only.
   Every visible string is rendered by Liquid from section settings;
   this file must never contain customer-facing copy. */
(function () {
  'use strict';

  /* ---------- storage (private-mode safe) ---------- */
  const store = (() => {
    try { localStorage.setItem('__t', '1'); localStorage.removeItem('__t'); return localStorage; }
    catch (e) { const m = {}; return { getItem: k => (k in m ? m[k] : null), setItem: (k, v) => { m[k] = String(v); }, removeItem: k => { delete m[k]; } }; }
  })();

  /* the shop spans many market subdomains (de./fr./jp. …); localStorage is
     per-origin, so a parent-domain cookie carries the state across the
     currency/language switches that navigate between them */
  const COOKIE_DOMAIN = /(^|\.)feetup\.com$/.test(location.hostname) ? ';domain=.feetup.com' : '';
  function writeCookie(v) {
    try { document.cookie = 'fu_quiz=' + encodeURIComponent(v) + COOKIE_DOMAIN + ';path=/;max-age=2592000;SameSite=Lax'; } catch (e) {}
  }
  function clearCookie() {
    try { document.cookie = 'fu_quiz=' + COOKIE_DOMAIN + ';path=/;max-age=0;SameSite=Lax'; } catch (e) {}
  }
  function readCookie() {
    try {
      const m = document.cookie.match(/(?:^|;\s*)fu_quiz=([^;]+)/);
      return m ? decodeURIComponent(m[1]) : null;
    } catch (e) { return null; }
  }
  function parse(v) { try { return JSON.parse(v || 'null'); } catch (e) { return null; } }
  const _ls = parse(store.getItem('fu_quiz'));
  const _ck = parse(readCookie());
  /* freshest copy wins: covers round-trips between market subdomains */
  const _best = (_ls && _ck) ? (((_ck.ts || 0) > (_ls.ts || 0)) ? _ck : _ls) : (_ls || _ck);
  const S = _best || {
    sid: Math.random().toString(36).slice(2, 10),
    path: null, blocker: null, practice: null, confidence: null, goal: null,
    history: [], current: null, model: null, fin: null, care: false, gidx: 0
  };
  function save() { S.ts = Date.now(); const v = JSON.stringify(S); store.setItem('fu_quiz', v); writeCookie(v); }
  /* first-touch UTMs: captured once per journey, sent with every beacon */
  try {
    const q = new URLSearchParams(location.search);
    const u = {};
    ['source', 'medium', 'campaign', 'content', 'term'].forEach(k => { const v = q.get('utm_' + k); if (v) u[k] = v.slice(0, 120); });
    if (Object.keys(u).length && !S.utm) S.utm = u;
  } catch (e) {}
  if (_best || S.utm) save();

  /* ---------- analytics (transport pluggable) ---------- */
  function track(type, data) {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'quiz_' + type, quiz_sid: S.sid }, data || {})); } catch (e) {}
    /* beacon -> Cloudflare Worker -> D1 (funnel analytics); plain string body
       keeps it a simple request (no preflight), response is never read */
    try {
      const payload = JSON.stringify({
        sid: S.sid, e: type, d: data || {}, ct: Date.now(), utm: S.utm || null,
        loc: document.documentElement.lang || navigator.language || '',
        ref: document.referrer || ''
      });
      const BEACON = 'https://feetup-quiz-beacon.woodbros.workers.dev/quiz-beacon';
      if (navigator.sendBeacon) navigator.sendBeacon(BEACON, payload);
      else fetch(BEACON, { method: 'POST', body: payload, keepalive: true });
    } catch (e) {}
  }
  window.quizTrack = track;

  /* ---------- slides ---------- */
  const stage = document.getElementById('quizStage');
  const slides = {};
  document.querySelectorAll('.qz-slide').forEach(el => { slides[el.dataset.slide] = el; });

  const DEPTH = { J0: 0, A1: 1, B1: 1, C1: 1, A2F: 2, A2B: 2, A2W: 2, B2S: 2, B2N: 2, B2U: 2, B2H: 2, C2S: 2, C2P: 2, C2T: 2, WHY: 3.5, S1: 5, BQ: 5.5, BULK: 5.8, SEL1: 7, SEL2: 8, SEL3: 9, END: 10 };
  let current = null;

  /* hierarchical downstream reset: re-answering upstream clears downstream */
  const DOWN = {
    path: ['blocker', 'practice', 'confidence', 'goal', 'model', 'fin', 'care'],
    blocker: ['practice', 'confidence', 'goal', 'model', 'fin', 'care'],
    practice: ['confidence', 'goal', 'model', 'fin', 'care'],
    confidence: ['goal', 'model', 'fin', 'care'],
    goal: ['model', 'fin', 'care']
  };

  let pushedDepth = 0; /* browser-history entries created this pageload (safe history.back() budget) */
  function go(id, soft) {
    if (!slides[id]) return;
    if (!soft) {
      if (current) S.history.push(current);
      track('slide_view', { slide: id });
      try {
        if (current) { history.pushState({ slide: id }, '', location.pathname); pushedDepth++; }
        else history.replaceState({ slide: id }, '', location.pathname);
      } catch (err) {}
    }
    current = id; S.current = id; save();
    Object.values(slides).forEach(el => { el.hidden = true; });
    const el = slides[id];
    el.hidden = false;
    el.classList.remove('on'); void el.offsetWidth; el.classList.add('on');
    hint(el, id);
    if (el.querySelector('[data-q-teach="yes"]')) {
      const isTeach = S.practice === 'teach';
      el.querySelectorAll('[data-q-teach]').forEach(q => { q.hidden = (q.dataset.qTeach === 'yes') !== isTeach; });
    }
    if (window.quizSel) {
      if (id === 'S1' || id === 'SEL1' || id === 'BQ') window.quizSel.preload();
      if (id === 'S1') window.quizSel.reviews();
      if (id.indexOf('SEL') === 0) window.quizSel.render(id);
    }
    const prog = document.getElementById('quizProgress');
    if (prog) prog.firstElementChild.style.width = ((DEPTH[id] !== undefined ? DEPTH[id] : 5) / 10 * 100) + '%';
    const back = document.getElementById('quizBack');
    if (back) back.hidden = S.history.length === 0;
    window.scrollTo(0, 0);
    if (stage) stage.scrollTop = 0;
    if (typeof window.quizFitInfog === 'function') window.quizFitInfog();
  }
  window.quizGo = go;

  /* "Common questions" hint above the dark band */
  function hint(slideEl, id) {
    slideEl.querySelectorAll('.qhint').forEach(h => h.remove());
    const band = slideEl.querySelector('.expands');
    const inner = slideEl.querySelector('.inner');
    if (!band || !inner) return;
    const kids = [...inner.children].filter(el => !el.classList.contains('expands') && !el.classList.contains('qhint'));
    const host = kids[kids.length - 1];
    if (!host) return;
    const labelEl = document.getElementById('quizHintLabel');
    const label = labelEl && labelEl.textContent.trim();
    if (!label) return;
    const h = document.createElement('button');
    h.type = 'button'; h.className = 'qhint'; h.textContent = label;
    h.onclick = () => { track('expand', { slide: id, topic: '(hint-scroll)' }); band.scrollIntoView({ behavior: 'smooth' }); };
    host.insertAdjacentElement('afterend', h);
  }

  /* ---------- event delegation ---------- */
  document.addEventListener('click', e => {
    const ans = e.target.closest('[data-goto]');
    if (ans) {
      const key = ans.dataset.setKey, val = ans.dataset.setValue;
      if (key) {
        (DOWN[key] || []).forEach(d => { S[d] = null; });
        S[key] = val;
      }
      let dest = ans.dataset.goto;
      if (dest === '@s1next') dest = (S.practice === 'teach') ? 'BQ' : 'SEL1';
      track('answer', { slide: current, answer: ans.textContent.trim(), key: key || null, code: val || null, goto: dest });
      go(dest);
      return;
    }
    const qa = e.target.closest('[data-qa-toggle]');
    if (qa) {
      const exp = qa.closest('.exp');
      const expc = exp.querySelector('.expc');
      exp.classList.toggle('open');
      if (exp.classList.contains('open')) {
        if (expc) expc.style.maxHeight = expc.scrollHeight + 'px';
        track('expand', { slide: current, topic: qa.dataset.topic });
      } else if (expc) {
        expc.style.maxHeight = '';
      }
      return;
    }
  });

  /* video plays */
  document.addEventListener('play', e => {
    if (e.target.matches && e.target.matches('.qz-video, .qz-video video, video')) {
      track('video_play', { slide: current, video: (e.target.currentSrc || '').split('/').pop() });
    }
  }, true);

  /* header */
  function backInternal() {
    const prev = S.history.pop();
    if (!prev) return;
    track('answer', { slide: current, answer: '(back)' });
    go(prev, true);
    save();
  }
  const backBtn = document.getElementById('quizBack');
  if (backBtn) backBtn.addEventListener('click', () => {
    if (!S.history.length) return;
    /* steps taken this pageload live in browser history; older (restored) steps only in S.history */
    if (pushedDepth > 0) { try { history.back(); return; } catch (err) {} }
    backInternal();
  });

  /* logo = restart: same effect as ?restart=1, without the reload */
  const logo = document.querySelector('.qh-logo');
  if (logo) logo.addEventListener('click', e => {
    e.preventDefault();
    track('answer', { slide: current, answer: '(logo-restart)' });
    store.removeItem('fu_quiz');
    clearCookie();
    S.history = []; S.current = null;
    S.path = S.blocker = S.practice = S.confidence = S.model = S.fin = null;
    S.care = false; S.gidx = 0;
    current = null; /* fresh journey: nothing to go back to */
    go(stage.dataset.startSlide || 'J0', false);
  });

  /* browser back/forward walks the slides too */
  window.addEventListener('popstate', e => {
    const id = e.state && e.state.slide;
    if (!id || !slides[id] || id === current) return;
    const top = S.history[S.history.length - 1];
    if (id === top) {
      S.history.pop();
      pushedDepth = Math.max(0, pushedDepth - 1);
      track('answer', { slide: current, answer: '(back)' });
    } else {
      S.history.push(current);
      pushedDepth++;
      track('slide_view', { slide: id });
    }
    go(id, true);
    save();
  });
  const closeBtn = document.getElementById('quizClose');
  const modal = document.getElementById('quizSkipModal');
  if (closeBtn && modal) {
    closeBtn.addEventListener('click', () => { track('skip_to_shop', { slide: current, via: 'close-x' }); modal.hidden = false; });
    modal.addEventListener('click', e => { if (e.target === modal) modal.hidden = true; });
    const stay = document.getElementById('quizSkipStay');
    if (stay) stay.addEventListener('click', () => { track('skip_stay', { slide: current }); modal.hidden = true; });
  }


  /* ================= SEL module: product data, reviews, selection, cart ================= */
  (function () {
    const pd = document.getElementById('quizProductData');
    const sd = document.getElementById('quizSelStrings');
    if (!pd || !sd) return;
    const P = JSON.parse(pd.textContent);
    const STR = JSON.parse(sd.textContent);
    const sym = P.currency || '$';
    const renames = {};
    (P.rename || '').split('\n').forEach(l => { const m = l.split('=>'); if (m.length === 2) renames[m[0].trim()] = m[1].trim(); });
    const money = v => { const r = Math.round(v * 100) / 100; return sym + r.toLocaleString(undefined, r % 1 ? { minimumFractionDigits: 2, maximumFractionDigits: 2 } : { maximumFractionDigits: 0 }); };

    /* build per-model finish lists with full gallery blocks (live-store block logic) */
    function galleries() {
      const blocks = {}; let cur = null;
      P.images.forEach(im => {
        if (im.vars.length) { cur = im.vars[0]; blocks[cur] = [im.src]; }
        else if (cur) blocks[cur].push(im.src);
      });
      return blocks;
    }
    const G = galleries();
    const FINS = { classic: [], two: [] };
    P.variants.forEach(v => {
      const isTwo = v.title.indexOf(P.prefix) === 0;
      const raw = isTwo ? v.title.slice(P.prefix.length) : v.title;
      const disp = renames[raw] || raw;
      FINS[isTwo ? 'two' : 'classic'].push({ id: v.id, raw: v.title, n: disp, p: v.price, cmp: v.cmp, qty: v.qty, available: v.available, img: v.img, g: G[v.id] || [v.img] });
    });
    /* the Quiz offers only the variant set configured in the SEL1 section settings */
    const OFFER = { classic: (STR.offerClassic || '').split(','), two: (STR.offerTwo || '').split(',') };
    ['classic', 'two'].forEach(m => { FINS[m] = FINS[m].filter(f => OFFER[m].map(t => t.trim()).indexOf(f.raw) >= 0); });

    function curFins() { return FINS[S.model === 'two' ? 'two' : 'classic']; }
    function curFin() { const f = curFins(); return f.find(x => x.n === S.fin) || f[0]; }
    function modelName() { return S.model === 'two' ? STR.modelTwo : STR.modelClassic; }
    const off = f => Math.round((1 - f.p / f.cmp) * 100);

    function priceHTML(f) {
      return money(f.p) + ' <s>' + money(f.cmp) + '</s> <span class="offchip">-' + off(f) + '%</span><span style="font-size:15px;color:var(--muted)"> · ' + STR.priceMeta.replace('{model}', modelName()).replace('{fin}', f.n) + '</span>';
    }
    function stockHTML(f) {
      if (!f.available || f.qty <= 0) return '<span class="stockwarn">' + STR.soldoutLabel + '</span>';
      return f.qty <= STR.stockThreshold ? '<span class="stockwarn">' + STR.stockLabel + '</span>' : '';
    }

    /* ---------- S1 reviews ---------- */
    function reviews() {
      const key = S.path === 'inverts' ? 'yogi'
        : S.blocker === 'discomfort' ? 'neck'
        : S.blocker === 'hold' ? 'body'
        : (['fear', 'body', 'neck', 'why'].indexOf(S.blocker) >= 0 ? S.blocker : 'body');
      document.querySelectorAll('#quizReviews .pcard').forEach(c => {
        const tags = (c.dataset.audience || '').split(',').map(t => t.trim());
        c.hidden = !(tags.indexOf(key) >= 0 || tags.indexOf('always') >= 0);
      });
    }

    /* ---------- SEL1 ---------- */
    function sel1() {
      const recClassic = (S.blocker === 'body' || S.practice === 'teach');
      const recModel = recClassic ? 'classic' : 'two';
      const recFinRaw = recClassic ? 'Classic White' : 'Honey Chai';
      const prof = [];
      if (S.path && STR.path[S.path]) prof.push(STR.path[S.path]);
      if (S.practice && STR.prac[S.practice]) prof.push(STR.prac[S.practice]);
      if (S.blocker && STR.why[S.blocker]) prof.push(STR.why[S.blocker]);
      const el = document.getElementById('quizProfile');
      if (el) el.textContent = (prof.join(', ') + '. ' + STR.suffix).replace(/^\. /, '');
      const cta = document.getElementById('quizRecCta');
      if (cta) {
        const name = recClassic ? STR.modelClassic : STR.modelTwo;
        const subText = STR.recCta.replace('{name}', name).replace('{fin}', recFinRaw);
        cta.textContent = '';
        const fullRaw = recModel === 'two' ? P.prefix + recFinRaw : recFinRaw;
        const rec = (FINS[recModel] || []).find(f => f.raw === fullRaw);
        if (rec && rec.img) {
          const th = document.createElement('img'); th.className = 'cta-thumb';
          th.src = rec.img.replace('width=800', 'width=160'); th.alt = subText;
          cta.append(th);
        }
        const lines = document.createElement('span'); lines.className = 'cta-lines';
        const main = document.createElement('span'); main.className = 'cta-main'; main.textContent = STR.recCtaMain;
        const sub = document.createElement('span'); sub.className = 'cta-sub'; sub.textContent = subText;
        lines.append(main, sub);
        cta.append(lines);
        cta.dataset.recModel = recModel; cta.dataset.recFin = recFinRaw;
      }
      document.querySelectorAll('[data-rec-chip]').forEach(ch => { ch.hidden = ch.dataset.recChip !== recModel; });
    }
    document.addEventListener('click', e => {
      const rc = e.target.closest('#quizRecCta');
      if (rc) { S.model = rc.dataset.recModel; S.fin = rc.dataset.recFin; S.gidx = 0; save(); track('answer', { slide: 'SEL1', answer: 'recommended_default' }); }
    }, true);

    /* ---------- SEL2 ---------- */
    function sel2() {
      const fins = curFins();
      if (!S.fin || !fins.find(f => f.n === S.fin)) S.fin = fins[0].n;
      const cur = curFin();
      const gi = Math.min(S.gidx || 0, cur.g.length - 1);
      const finsEl = document.getElementById('quizFins');
      if (finsEl) finsEl.innerHTML = fins.map(f =>
        '<button type="button" class="fin' + (f.n === S.fin ? ' sel' : '') + '" data-fin="' + f.n + '">' +
        '<img src="' + f.img + '" alt="' + f.n + '"><span class="fintxt">' + f.n + '<small>' + money(f.p) + '</small></span>' +
        '<span class="finoff">-' + off(f) + '%</span></button>').join('');
      const main = document.getElementById('selMain');
      if (main) { main.src = cur.g[gi]; main.alt = STR.priceMeta.replace('{model}', modelName()).replace('{fin}', cur.n); main.style.cursor = 'zoom-in'; }
      const th = document.getElementById('selThumbs');
      if (th) th.innerHTML = cur.g.map((src, i) => '<img src="' + src.replace('width=1600', 'width=160') + '" class="' + (i === gi ? 'on' : '') + '" alt="" data-thumb="' + i + '">').join('');
      const pr = document.getElementById('selPrice'); if (pr) pr.innerHTML = priceHTML(cur);
      const st = document.getElementById('selStock'); if (st) st.innerHTML = stockHTML(cur);
      cur.g.slice(0, 6).forEach(src => { const i = new Image(); i.src = src; });
    }
    document.addEventListener('click', e => {
      const fin = e.target.closest('.fin');
      if (fin) { S.fin = fin.dataset.fin; S.gidx = 0; save(); track('sel_finish', { value: S.fin }); sel2(); return; }
      const th = e.target.closest('[data-thumb]');
      if (th) { S.gidx = +th.dataset.thumb; save(); track('expand', { slide: 'SEL2', topic: 'gallery-' + S.gidx }); sel2(); return; }
      if (e.target.closest('#selMain')) { lbOpen(); return; }
    });

    /* ---------- lightbox ---------- */
    const lb = document.getElementById('quizLightbox');
    function lbRender() {
      const cur = curFin(), gi = Math.min(S.gidx || 0, cur.g.length - 1);
      document.getElementById('lbImg').src = cur.g[gi];
      document.getElementById('lbCount').textContent = (gi + 1) + ' / ' + cur.g.length;
      [gi + 1, gi - 1].forEach(k => { const n = (k + cur.g.length) % cur.g.length; const i = new Image(); i.src = cur.g[n]; });
    }
    function lbOpen() { if (!lb) return; track('expand', { slide: 'SEL2', topic: 'lightbox-open' }); lb.hidden = false; document.body.style.overflow = 'hidden'; lbRender(); }
    function lbClose() { if (!lb) return; lb.hidden = true; document.body.style.overflow = ''; }
    function lbGo(d) {
      const cur = curFin(), n = cur.g.length;
      S.gidx = ((Math.min(S.gidx || 0, n - 1)) + d + n) % n; save();
      const im = document.getElementById('lbImg'); im.style.opacity = .35;
      lbRender(); im.onload = () => { im.style.opacity = 1; };
      sel2();
    }
    if (lb) {
      lb.addEventListener('click', e => {
        if (e.target === lb) lbClose();
        else if (e.target.id === 'lbClose') lbClose();
        else if (e.target.id === 'lbPrev') lbGo(-1);
        else if (e.target.id === 'lbNext') lbGo(1);
      });
      document.addEventListener('keydown', e => {
        if (lb.hidden) return;
        if (e.key === 'Escape') lbClose();
        else if (e.key === 'ArrowRight') lbGo(1);
        else if (e.key === 'ArrowLeft') lbGo(-1);
      });
      let x0 = null;
      lb.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
      lb.addEventListener('touchend', e => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) > 40) lbGo(dx < 0 ? 1 : -1); }, { passive: true });
    }

    /* ---------- SEL3 ---------- */
    function sel3() {
      const cur = curFin();
      const variant = (S.practice === 'teach') ? 'teach' : (S.path || 'never');
      document.querySelectorAll('[data-t-variant]').forEach(h => { h.hidden = h.dataset.tVariant !== variant; });
      const o = (S.practice === 'teach') ? 'teach' : 'default';
      document.querySelectorAll('[data-t-variant2]').forEach(p => { p.hidden = p.dataset.tVariant2 !== o; });
      const parts = cur.n.split(' ');
      const sub = STR.finPattern.replace('{frame}', parts[0]).replace('{cushion}', parts.slice(1).join(' '));
      const set = (id, v, prop) => { const el = document.getElementById(id); if (el) el[prop || 'textContent'] = v; };
      set('quizTrainerThumb', cur.g[0].replace('width=1600', 'width=240'), 'src');
      set('quizTrainerTitle', S.model === 'two' ? STR.trainerTwo : STR.trainerClassic);
      set('quizTrainerSub', sub);
      set('quizTrainerCmp', money(cur.cmp));
      set('quizTrainerPrice', money(cur.p));
      totals();
      const arr = document.getElementById('quizArrivalLine');
      if (arr) {
        const d = new Date(); d.setDate(d.getDate() + (+arr.dataset.days || 5));
        const ds = d.toLocaleDateString(document.documentElement.lang || undefined, { weekday: 'long', month: 'long', day: 'numeric' });
        arr.textContent = arr.dataset.pattern.replace('{date}', ds);
      }
      const care = document.getElementById('careBox');
      if (care) { care.classList.toggle('sel', !!S.care); care.querySelector('input').checked = !!S.care; }
    }
    function totals() {
      const cur = curFin();
      const tr = document.getElementById('totRow');
      if (!tr) return;
      const carePrice = +tr.dataset.carePrice || 0;
      /* extras: sum the rows' backend-derived values; static setting is the fallback */
      let extras = 0, dynamicRows = 0;
      const rowVals = document.querySelectorAll('.qz-slide[data-slide="SEL3"] .rowi:not(#quizTrainerRow) .rprice s[data-val]');
      rowVals.forEach(function (el) { extras += (+el.dataset.val || 0); dynamicRows++; });
      const totalRows = document.querySelectorAll('.qz-slide[data-slide="SEL3"] .rowi:not(#quizTrainerRow)').length;
      if (!dynamicRows || dynamicRows < totalRows) extras = +tr.dataset.extrasValue || 0;
      const pay = cur.p + (S.care ? carePrice : 0);
      const value = cur.cmp + extras + (S.care ? carePrice : 0);
      document.getElementById('quizTotValue').textContent = money(value);
      document.getElementById('quizTotPay').textContent = money(pay);
      document.querySelectorAll('[data-min-total]').forEach(chip => { chip.hidden = !(pay > +chip.dataset.minTotal); });
    }
    document.addEventListener('click', e => {
      if (e.target.closest('#careBox')) {
        S.care = !S.care; save(); track('answer', { slide: 'SEL3', answer: 'care_' + (S.care ? 'on' : 'off') });
        const care = document.getElementById('careBox');
        care.classList.toggle('sel', S.care); care.querySelector('input').checked = S.care;
        totals();
      }
    });

    /* ---------- add to cart: real cart + journey note ---------- */
    const atc = document.getElementById('quizAddToCart');
    function atcBusy(on) {
      atc.disabled = on;
      atc.classList.toggle('loading', on);
      if (on) {
        atc.dataset.origLabel = atc.textContent;
        if (atc.dataset.loadingLabel) atc.textContent = atc.dataset.loadingLabel;
      } else if (atc.dataset.origLabel) {
        atc.textContent = atc.dataset.origLabel;
      }
    }
    function finDisplay(vid) {
      const f = FINS.classic.concat(FINS.two).find(x => x.id === vid);
      if (!f) return '';
      const model = FINS.two.some(x => x.id === vid) ? STR.modelTwo : STR.modelClassic;
      return STR.priceMeta.replace('{model}', model).replace('{fin}', f.n);
    }
    /* duplicate-in-cart dialog: resolves 'main' / 'alt' / null (dismissed) */
    function dupDialog(mode, oldName, newName) {
      return new Promise(function (resolve) {
        const m = document.getElementById('quizDupModal');
        if (!m) { resolve('alt'); return; }
        const s = (document.getElementById('quizDupStrings') || {}).dataset || {};
        const body = document.getElementById('quizDupBody');
        const main = document.getElementById('quizDupMain');
        const alt = document.getElementById('quizDupAlt');
        if (mode === 'same') {
          body.textContent = m.dataset.bodySame || '';
          main.textContent = s.keep || ''; alt.textContent = s.add || '';
        } else {
          body.textContent = (m.dataset.bodySwap || '').replace('{old}', oldName).replace('{new}', newName);
          main.textContent = s.replace || ''; alt.textContent = s.both || '';
        }
        function done(v) {
          m.hidden = true;
          main.onclick = alt.onclick = m.onclick = null;
          document.removeEventListener('keydown', esc);
          resolve(v);
        }
        function esc(e) { if (e.key === 'Escape') done(null); }
        main.onclick = function () { done('main'); };
        alt.onclick = function () { done('alt'); };
        m.onclick = function (e) { if (e.target === m) done(null); };
        document.addEventListener('keydown', esc);
        m.hidden = false;
        main.focus();
      });
    }
    if (atc) atc.addEventListener('click', async () => {
      const cur = curFin();
      atcBusy(true);
      const careVariant = +((document.getElementById('totRow') || {}).dataset || {}).careVariant || 0;
      const props = { '_quiz_sid': S.sid };
      if (S.path) props['_quiz_path'] = S.path;
      if (S.blocker) props['_quiz_blocker'] = S.blocker;
      if (S.practice) props['_quiz_practice'] = S.practice;
      if (S.confidence) props['_quiz_confidence'] = S.confidence;
      if (S.care) props['_quiz_care_requested'] = 'yes';
      /* visible "Includes: …" line under the Trainer in cart/checkout — titles read
         from the rendered SEL3 rows so langify's translation carries over */
      const incEl = document.getElementById('quizIncludesLabel');
      const incLabel = incEl && incEl.textContent.trim();
      const incItems = Array.prototype.slice.call(
        document.querySelectorAll('.qz-slide[data-slide="SEL3"] .rowi:not(#quizTrainerRow) .rtxt b')
      ).map(function (b) { return b.textContent.trim(); }).filter(Boolean);
      if (incLabel && incItems.length) props[incLabel] = incItems.join(' · ');
      async function noteAndCheckout() {
        const note = 'Quiz: ' + (S.model === 'two' ? 'Upgraded' : 'Original') + ' / ' + cur.raw +
          ' | path=' + (S.path || '-') + ' blocker=' + (S.blocker || '-') + ' practice=' + (S.practice || '-') +
          ' confidence=' + (S.confidence || '-') + (S.care ? ' | CARE REQUESTED' : '') + ' | sid=' + S.sid;
        const attrs = { 'Quiz session': S.sid };
        if (S.path) attrs['Quiz path'] = S.path;
        if (S.blocker) attrs['Quiz blocker'] = S.blocker;
        if (S.practice) attrs['Quiz practice'] = S.practice;
        if (S.confidence) attrs['Quiz confidence'] = S.confidence;
        attrs['Quiz model'] = (S.model === 'two' ? 'Upgraded' : 'Original') + ' / ' + cur.raw;
        if (S.care) attrs['Quiz care requested'] = 'yes';
        await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note, attributes: attrs }) });
        location.href = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'checkout';
      }
      async function removeLine(key) {
        await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) });
      }
      try {
        /* inspect the cart first: the quiz recommends a setup, it shouldn't silently accumulate */
        const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
        const trainerIds = P.variants.map(function (v) { return v.id; });
        const inCartTrainers = cart.items.filter(function (i) { return trainerIds.indexOf(i.variant_id) >= 0; });
        const careLine = careVariant ? cart.items.find(function (i) { return i.variant_id === careVariant; }) : null;
        const same = inCartTrainers.find(function (i) { return i.variant_id === cur.id; });
        const quizOther = inCartTrainers.find(function (i) { return i.variant_id !== cur.id && i.properties && i.properties._quiz_sid; });
        let addTrainer = true;
        if (same) {
          const choice = await dupDialog('same');
          if (choice === null) { atcBusy(false); return; }
          if (choice === 'main') {
            addTrainer = false; /* keep 1, go to checkout */
            if (careLine && careLine.properties && careLine.properties._quiz_care && !S.care) await removeLine(careLine.key);
          }
          track('answer', { slide: 'SEL3', answer: 'dup_' + (addTrainer ? 'add_second' : 'keep_one') });
        } else if (quizOther) {
          const choice = await dupDialog('swap', finDisplay(quizOther.variant_id), finDisplay(cur.id));
          if (choice === null) { atcBusy(false); return; }
          if (choice === 'main') {
            await removeLine(quizOther.key); /* replace: drop the earlier quiz pick */
            if (careLine && careLine.properties && careLine.properties._quiz_care && !S.care) await removeLine(careLine.key);
          }
          track('answer', { slide: 'SEL3', answer: 'dup_' + (choice === 'main' ? 'replace' : 'keep_both') });
        }
        const payAmount = cur.p + (S.care ? (+document.getElementById('totRow').dataset.carePrice || 0) : 0);
        const items = [];
        if (addTrainer) items.push({ id: cur.id, quantity: 1, properties: props });
        if (S.care && careVariant && !careLine) items.push({ id: careVariant, quantity: 1, properties: { _quiz_care: 'yes' } });
        if (items.length) {
          const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) });
          if (!r.ok) throw new Error('add failed');
        }
        /* only counted once the cart really accepted it */
        track('add_to_cart', { value: sym + payAmount, amount: payAmount, currency: P.currency_iso || null, variant: cur.raw, code: S.care ? 'with_care' : 'no_care' });
        await noteAndCheckout();
      } catch (err) {
        track('add_to_cart_error', { slide: 'SEL3', variant: cur.raw, reason: String(err && err.message || err).slice(0, 120) });
        atcBusy(false);
        location.href = '/cart';
      }
    });

    /* ---------- bulk ---------- */
    const bs = document.getElementById('quizBulkSend');
    if (bs) bs.addEventListener('click', () => {
      const em = document.getElementById('quizBulkEmail');
      track('answer', { slide: 'BULK', answer: 'bulk_quote_request', key: 'bulk', code: (em && em.value) ? 'with_email' : 'no_email' });
      bs.textContent = bs.dataset.sentLabel;
    });

    window.quizSel = {
      preload: function () { [].concat(FINS.classic, FINS.two).forEach(f => { const i = new Image(); i.src = f.img; }); },
      reviews: reviews,
      render: function (id) { if (id === 'SEL1') sel1(); else if (id === 'SEL2') sel2(); else if (id === 'SEL3') sel3(); }
    };
  })();

  /* ---------- WHY infographic: locked-unit scaling ---------- */
  window.quizFitInfog = function () {
    const w = document.querySelector('.qz-slide:not([hidden]) .igwrap') || document.querySelector('.igwrap');
    if (!w) return;
    if (!w.__ro) { w.__ro = new ResizeObserver(() => window.quizFitInfog()); w.__ro.observe(w); }
    const sc = w.clientWidth / 1100;
    const cv = w.querySelector('.igcanvas');
    if (cv) { cv.style.transform = 'scale(' + sc + ')'; w.style.height = (1186 * sc) + 'px'; }
  };
  window.addEventListener('resize', () => window.quizFitInfog());

  /* ---------- boot: ?slide= param > saved position > start slide ---------- */
  S.history = (S.history || []).filter(id => slides[id]);
  const params = new URLSearchParams(location.search);
  if (params.get('restart')) { store.removeItem('fu_quiz'); clearCookie(); S.history = []; S.current = null; S.path = S.blocker = S.practice = S.confidence = S.model = S.fin = null; S.care = false; }
  const qslide = params.get('slide');
  const startAt = stage.dataset.startSlide || 'J0';
  if ((store.getItem('fu_quiz') || '') === '') track('journey_start', {});
  if (qslide && slides[qslide]) { current = qslide; go(qslide, true); }
  else if (S.current && slides[S.current]) { current = S.current; go(S.current, true); }
  else { S.history.length = 0; go(startAt, false); }
  const back = document.getElementById('quizBack');
  if (back) back.hidden = S.history.length === 0;
  /* seed the browser entry for the boot slide; drop one-shot params from the address bar */
  try {
    params.delete('restart'); params.delete('slide');
    const qs = params.toString();
    history.replaceState({ slide: current }, '', location.pathname + (qs ? '?' + qs : ''));
  } catch (err) {}

  window.quizState = S;
  window.quizSave = save;
})();
